import { VideoTime, VideoTimeStringified } from "../types/videoTime";

const appendZero = (time: number): string =>
  time < 10 ? `0${time}` : time.toString();

const hours = (time: number) => Math.floor(time / 3600);

const minutes = (time: number) => Math.floor((time % 3600) / 60);

const seconds = (time: number) => Math.floor((time % 3600) % 60);

export const timeToString = (time: number, hasHours: boolean): string => {
  return hasHours
    ? `${hours(time)}:${appendZero(minutes(time))}:${appendZero(seconds(time))}`
    : `${minutes(time)}:${appendZero(seconds(time))}`;
};

export const hasHours = (duration: number) => hours(duration) > 0;

export const videoTimeToString = (
  videoTime: VideoTime
): VideoTimeStringified => {
  const hourIncluded = hasHours(videoTime.duration);

  return {
    duration: timeToString(videoTime.duration, hourIncluded),
    currentTime: timeToString(videoTime.currentTime, hourIncluded),
  };
};
